export default function () {
  if (this.$route.params?.plan) {
    if (this.$route.params.plan !== 'all') {
      this.filters.plan.push(`/plans/${this.$route.params.plan}`)
    }
  }

  if (this.$route.params?.email) {
    this.filters['teacher.email'] = this.$route.params?.email
  }

  this.loadSubscriptions()
}
